export default __webpack_public_path__ + "static/download-pdf-8df2497dcb45bb001e9aad9b843e8e79.png";